import kformUtils from "../../utils/kform-utils";

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	if ($scope.options && $scope.options.building) {
		return;
	}
	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
	$scope.removeValue = (/** @type {number} */ index) => {
		$scope.data[$scope.component.key][index].kid = undefined;
		$scope.changeValue();
	}
};
